var map = {
	"./01_StudioMatce.png": 8982,
	"./03_Audi.png": 6766,
	"./04_A2a.png": 8526,
	"./05_Irinox.png": 2154,
	"./06_Corbanese.png": 9066,
	"./07_Vibranium.png": 3184,
	"./08_Dema.png": 7371,
	"./09_CentroMedicina.png": 9468,
	"./10_Origama.png": 8954,
	"./12_Alfieri.png": 1657,
	"./14_CreditAgricole.png": 8394,
	"./15_SerenaWines.png": 1737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8361;